import { useEffect } from 'react';
import { sliderModifiers, sliderTokens } from '@ui/kit/selectors';
import { debounce, throttleToAnimationFrame, clamp } from '@utils/common';
import { applyCssDeclarations } from '@utils/css';

const config = {
  container: {
    min: 600,
    max: 1865
  },
  clamp: {
    min: 1.65,
    max: 5
  }
};
function useDynamicItemsPerPage(ref) {
  useEffect(() => {
    const target = ref.current;
    if (!target) {
      return;
    }
    const onFinish = debounce(() => {
      target.classList.remove(sliderModifiers.disableTransition.className);
    }, 350);
    const onResize = () => {
      if (window.innerWidth < 600) {
        applyCssDeclarations(sliderTokens.itemsPerPage.__override(1), ref);
        onFinish();
        return;
      }
      const itemsPerPage = getItemsPerPage(target.clientWidth);
      target.classList.add(sliderModifiers.disableTransition.className);
      applyCssDeclarations(sliderTokens.itemsPerPage.__override(itemsPerPage), ref);
      onFinish();
    };
    const observer = new ResizeObserver(throttleToAnimationFrame(onResize));
    onResize();
    observer.observe(target);
    return () => {
      observer.disconnect();
    };
  }, [ref]);
}
function getItemsPerPage(targetWidth) {
  const slope = (config.clamp.max - config.clamp.min) / (config.container.max - config.container.min);
  const yAxisIntersection = -600 * slope + config.clamp.min;
  const desiredItemsPerPage = yAxisIntersection + slope * targetWidth;
  const itemsPerPage = clamp(config.clamp.min, desiredItemsPerPage, config.clamp.max);
  return Math.max(1, itemsPerPage);
}

export { getItemsPerPage, useDynamicItemsPerPage };
//# sourceMappingURL=hook.items-per-page.js.map
